import React from "react";
import { motion } from 'framer-motion';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../assets/images/artseen-logo.png';

import './styles.css';


export default function NavBar() {
    return (
      <div>
        <Navbar expand="lg" className="navbar-background">
          <Navbar.Brand as={motion.div} whileHover={{ scale: 1.1 }} href="#home">
            <span className="artseen-text">
              <img src={logo} width="40" height="40" alt="ArtSeen Logo" />
              ArtSeen
            </span>
          </Navbar.Brand>
        </Navbar>
      </div>
    );
  }

